<template>
    <div>
        <div class="mb-3 pt-5 mt-5">
            <center>
                <hour-glass/>
            </center>
        </div>
        <h4 class="pb-5 mb-5">
            <center>
            Memuat..
            </center></h4>
        </div>
</template>
<script>
import {HourGlass} from 'vue-loading-spinner';
export default {
  name: "Loading",
  components: {HourGlass}
};
</script>